//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {},
    props: {
        title: String
    },
    data() {
        return {}
    },
    methods: {}
}
